function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgMedal = function SvgMedal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("circle", {
    style: {
      fill: "#FFD15C"
    },
    cx: 253.55,
    cy: 201.7,
    r: 201.7
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M90.15,319.7L20.75,440l81-4.3l36.8,72.3l64.2-111.3C156.75,384.8,117.25,357.1,90.15,319.7z"
  }), React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M417.35,319.1c-26.9,37.5-66.4,65.3-112.3,77.4l64.4,111.5l36.8-72.3l81,4.3L417.35,319.1z"
  })), React.createElement("circle", {
    style: {
      fill: "#F8B64C"
    },
    cx: 253.55,
    cy: 201.7,
    r: 146.2
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M353.75,185.9c4.5-4.4,2-12.1-4.2-13l-57.7-8.4c-2.5-0.4-4.6-1.9-5.7-4.2l-25.8-52.3 c-2.8-5.7-10.9-5.7-13.7,0l-25.7,52.3c-1.1,2.2-3.3,3.8-5.7,4.2l-57.7,8.4c-6.2,0.9-8.7,8.6-4.2,13l41.7,40.7 c1.8,1.8,2.6,4.3,2.2,6.7l-9.8,57.4c-1.1,6.2,5.5,11,11.1,8l51.6-27.1c2.2-1.2,4.9-1.2,7.1,0l51.6,27.1c5.6,2.9,12.1-1.8,11.1-8 l-9.9-57.4c-0.4-2.5,0.4-5,2.2-6.7L353.75,185.9z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMedal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medal.82bc677a.svg";
export { ForwardRef as ReactComponent };